import React from 'react'
import ReactGA from 'react-ga';
const GoogleAnalytics = ({ profile }) => {
    const TRACKING_ID = profile.ga_id;
    ReactGA.initialize(TRACKING_ID);
    return <div></div>;
};

export default GoogleAnalytics;